<form #studentDetailsForm="ngForm">
  <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
    <div class="tw:w-full tw:px-[15px] tw:md:w-1/2 tw:lg:w-2/3">
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2 tw:mb-6">
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            <div class="tw:w-full tw:px-[15px] tw:mb-12">
              <label class="field__label">Learner {{ studentIndex + 1 }}</label>
              <div class="tw:flex tw:items-center">
                <input class="field__control tw:w-full"
                  type="text"
                  [(ngModel)]="model.studentFullName"
                  name="studentFirstName"
                  [disabled]="true" />
                @if (!(disabled || lockStudents)) {
                  <mat-icon class="search-button tw:ml-2 cursor-pointer"
                    (click)="openStudentSearch()">search</mat-icon>
                }
              </div>
              @if (lockStudents) {
                <span class="field__hint tw:block tw:text-right">Cannot change learners in this booking</span>
              }
            </div>
          </div>
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            <div class="tw:w-full tw:px-[15px]">
              <label class="field__label">Attendance:</label>
              <select class="field__control tw:w-full"
                [(ngModel)]="model.attendance"
                [disabled]="disabled || model.studentId == 0"
                name="attendance"
                (change)="setAttendanceValidation()">
                @for (attendance of attendanceList; track attendance) {
                  <option [value]="attendance.text">{{ attendance.text }}</option>
                }
              </select>
            </div>
          </div>
        </div>
        <div class="tw:w-full tw:px-[15px] tw:lg:w-1/2">
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            <div class="tw:w-full tw:px-[15px] scale-rater-container">
              <label class="field__label">Engagement: @if (!(model.engagement > 0) && commentIsRequired) {
                <i class="tw:text-danger font-10">(mandatory)</i>
              }</label>
              <scale-rater
                [value]="model.engagement"
                (valueChange)="model.engagement = $event"
                [disabled]="disabled || model.studentId == 0">
              </scale-rater>
            </div>
          </div>
          <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
            <div class="tw:w-full tw:px-[15px] scale-rater-container">
              <label class="field__label">Comprehension: @if (!(model.comprehension > 0) && commentIsRequired) {
                <i class="tw:text-danger font-10">(mandatory)</i>
              }</label>
              <scale-rater
                [value]="model.comprehension"
                (valueChange)="model.comprehension = $event"
                [disabled]="disabled || model.studentId == 0">
              </scale-rater>
            </div>
          </div>
        </div>
      </div>
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:w-full tw:px-[15px] tw:mb-6" [hidden]="!reasonDescriptionIsRequired">
          <label class="field__label">Reason for being {{model.attendance.toLowerCase()}}: @if (!(model.reasonDescription && model.reasonDescription.length >= 4)) {
            <i class="tw:text-danger font-10">(mandatory - {{model.reasonDescription?.length || 0}}/4 required)</i>
          }</label>
          <textarea class="field__control tw:w-full"
            type="text"
            [(ngModel)]="model.reasonDescription"
            [disabled]="disabled || model.studentId == 0"
            name="reasonDescription"
            rows="4"
            maxlength="3000"></textarea>
          <span class="field__hint tw:block tw:text-right">{{model.reasonDescription?.length || 0}}/3000</span>
        </div>
        <div class="tw:w-full tw:px-[15px] tw:mb-6">
          <label class="field__label">Comments: @if (commentIsRequired && !(model.learnerComments && model.learnerComments.length >= 100)) {
            <i class="tw:text-danger font-10">(mandatory - {{model.learnerComments?.length || 0}}/100 required)</i>
          }</label>
          <textarea class="field__control tw:w-full"
            type="text"
            [(ngModel)]="model.learnerComments"
            [disabled]="disabled || model.studentId == 0"
            name="learnerComments"
            rows="4"
            maxlength="3000"></textarea>
          <span class="field__hint tw:block tw:text-right">{{model.learnerComments?.length || 0}}/3000</span>
        </div>
      </div>
    </div>

    <div class="tw:w-full tw:px-[15px] tw:md:w-1/2 tw:lg:w-1/3 timeline-preview">
      <div class="tw:flex tw:flex-wrap tw:-mx-[15px]">
        <div class="tw:flex-1 tw:px-[15px]">
          <latest-learning-section
            [learningSection]="model.latestLearningSection"
            (addLearningSectionClicked)="addStudentLearningSection()"
            (viewTimelineClicked)="viewStudentTimeline()"
          ></latest-learning-section>
        </div>
        <div class="tw:flex-none tw:w-auto tw:px-[15px]">
          <div class="padlock-icon-container"
            data-toggle="tooltip" data-placement="top" title="Grant access"
            (click)="grantStudentAccess()">
            <div class="padlock-icon cursor-pointer"></div>
          </div>
        </div>
      </div>
    </div>
  </div>
</form>
